import { render } from "./PersonalDonationStep2a.vue?vue&type=template&id=46042f89"
import script from "./PersonalDonationStep2a.vue?vue&type=script&lang=js"
export * from "./PersonalDonationStep2a.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__